import { format, parse } from 'date-fns';

export interface ExportDayBounds {
  earliestDate: Date | null;
  latestDate: Date;
}

export interface ExportAvailableDates {
  earliestDate?: string | null;
  latestDate?: string | null;
}

const REPORT_DATE_FORMAT = 'yyyy-MM-dd';
const REPORT_DATE_REFERENCE = new Date(0);

export function toReportDate(date: Date): string {
  return format(date, REPORT_DATE_FORMAT);
}

export function toExportDayBounds(available: ExportAvailableDates): ExportDayBounds | null {
  const latestDate = fromReportDate(available.latestDate);

  if (latestDate === null) {
    return null;
  }

  const earliestDate = fromReportDate(available.earliestDate);

  return {
    earliestDate: earliestDate !== null && earliestDate <= latestDate ? earliestDate : null,
    latestDate,
  };
}

function fromReportDate(value: string | null | undefined): Date | null {
  const candidate = typeof value === 'string' ? value.trim() : '';

  if (candidate.length === 0) {
    return null;
  }

  const parsed = parse(candidate, REPORT_DATE_FORMAT, REPORT_DATE_REFERENCE);

  if (Number.isNaN(parsed.getTime()) || format(parsed, REPORT_DATE_FORMAT) !== candidate) {
    return null;
  }

  return parsed;
}
